import { Price } from '../catalogue-category/price.model';
import { IProduct } from '../contract/product.contract';

export class SampleService implements IProduct {
    public discriminator;
    constructor(
        public id?: number,
        public name?: string,
        public price?: Price,
        public sampleTypeId?: number,
        public analyticalTestId?: number,
        public substanceId?: number
    ) {}

}
